<template>
  <div class="">
    <CCard>
<CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>      <ValidationObserver v-slot="{ handleSubmit }">
        <CForm @submit.prevent="handleSubmit(onPaymentFormSubmit)">
          <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
            <CRow class="flex-flow-column mob-mr-auto">
              <CCol>
                <strong>{{  selectedPayment? $t('addPayment.updateTitle'): $t('addPayment.title')}}</strong>
              </CCol>
              <p class="desc"> {{  selectedPayment? $t('addPayment.updateDesc'):$t('addPayment.desc')}}</p>
            </CRow>

          </CCardHeader>

          <CCardBody>
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <cTextInputComponent
                        v-model="payment.name"
                        :isDisable='selectedPayment?true:false'
                        :rules="selectedPayment? 'required': 'required|max:20'"
                        :label="$t('addPayment.name')"
                        @onInput="onEdit"
                >
                </cTextInputComponent>
              </div>
              <div class="col-md-6 col-sm-12">
                <cDropDown
                        v-model="payment.providerGroup"
                        :selValue="selectedPayment ? payment.providerGroup : null"
                        rules="required"
                       :isDisable='selectedPayment?true:false'
                        ctrlName="groupname"
                        :label="$t('addPayment.group')"
                        :url="getPaymentGroupsUrl()"
                        @input="onEdit"
                >
                </cDropDown>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <cDropDown 
                :isDisable='selectedPayment?true:false'
                        v-model="payment.provider"
                        :selValue="selectedPayment ? payment.provider : null"
                        rules="required"
                        ctrlName="providertype"
                         ctrlName1='cardtype'
                        :label="$t('addPayment.provider')"
                        :url="getPaymentProvidersUrl()"
                          @input="onEdit"
                >
                </cDropDown>
              </div>
              <div class="col-md-6 col-sm-12">
                <cOrgCurrencyDp
                v-if="GET_ORG_CURRENCY_RES"
                        v-model="payment.currencyList"
                        :selValue="selectedPayment ? payment.currencyList : null"
                        :ctrlCode="'id'"
                        :isShowCode="true"
                        :isMultiple="true"
                        :isSearchable="false"
                        rules="required"
                        :label="$t('addPayment.currency')"
                          @input="onEdit"
                >
                </cOrgCurrencyDp>
              </div>

            </div>
            <br />
<div class="row">
  <div class="col-md-6 col-sm-12">
     <label>
       {{$t('addPayment.status')}}
     </label>

     <cStatusButton    :isConfirm='false' :defaultStatus='payment.status.value'  @change='payment.status.value=!payment.status.value' :buttonDesc="$t('addPayment.btnDesc')" :label="{checked: $t('addPayment.activate'), unchecked: $t('addPayment.deactivate')}">
                        
                    </cStatusButton>






    <!-- <cDropDown

            v-if="selectedPayment"
            rules="required"
            v-model="payment.status"
            :selValue="payment.status"
            ctrlName="name"
            :label="$t('addPayment.status')"
            :url="getStatusUrl()"
    >
    </cDropDown> -->
  </div>
</div>



            <br />

            <div class="row">
              <div class="m-auto">

                <cPaymentTypes
                       :key="'create'"
                        v-if="
                    selectedPayment &&
                      payment.feeSettings &&
                      payment.feeSettings.length
                  "
                        @change="onPaymentTypeChange"
                        :selPayments="selectedPayment ? payment.feeSettings : null"
                >
                </cPaymentTypes>
                <cPaymentTypes
                        v-if="!selectedPayment"
                        :key="'update'"
                        @change="onPaymentTypeChange"
                >
                </cPaymentTypes>
              </div>
            </div>
          </CCardBody>
          <CCardFooter>
            <CCol class="text-right mob-btn-right">
              <CRow class="d-flex justify-content-end ">
               <CButton @click='navigateToPaymentSetup' color="danger"  class="action-c-btn">          
                    <img src="@imgPath/img/svg/icons/close.svg">

                {{ $t("addPayment.cancel") }}
                </CButton>

                <CButton class="buttonspace action-c-btn btn-success removewrap"
                         color="success removewrap" type="submit">
                  <img src="@imgPath/img/svg/icons/correct.svg">

                  {{ $t("addPayment.save") }}
                </CButton>

              </CRow>
            </CCol>


          </CCardFooter>


        </CForm>
      </ValidationObserver>
    </CCard>


     <cAlertModal
      v-if="isShowAlertModal"
      :buttonList="getAlertModalBtn()"
      :status="1"
      :show="isShowAlertModal"
      :desc="$t('addPayment.statusUpdate',{name:payment.name})"
    >
    </cAlertModal>
   
  </div>
</template>
<script>
import cDropDown from "./../../components/form/cDropDown";
import cOrgCurrencyDp from "./../../components/currency/cOrgCurrencyDp";
import cTextInputComponent from "./../../components/form/cTextInputComponent";
import cAlertModal from "./../../components/form/cAlertModal";
import cPaymentTypes from "./../../components/payment/cPaymentTypes.vue";
import Multiselect from "vue-multiselect";
import router, { navigate, goBack, updateDataEdited } from "../../router/index";
import { cloneData, removeDuplicates, OrderByList } from "./../../util/util";
import { ValidationObserver, localize } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import draggable from "vuedraggable";
import {
  PATHNAME,
  COMPONENT_NAME,
  DEFAULT_DROPDOWN_STATUS
} from "./../../util/constants";
import apiCreatePayment from "./../../services/apiCreatePayment";
import apiUpdatePayment from "./../../services/apiUpdatePayment";
import Logger from "./../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES,
  API_VALUES
} from "./../../config/API_DATA";
import BaseConfiguration from "./../../config/base";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "../../util/apiValidate";
import { handleJWT, getErrorAlertValue,addClassToBody,removeClassBody } from "../../util/util";
import apiGetPaymentTypes from './../../services/apiGetPaymentTypes'
import cStatusButton from './../../components/form/cStatusButton'
// import nb from "../../translations/validation/nb.json";
// import en from "../../translations/validation/en.json";
// localize({
//   en: {
//     messages: en.messages
//   },
//   nb: {
//     messages: nb.messages
//   }
// });
export default {
  name: COMPONENT_NAME.ADD_PAYMENT,
  components: {
    cTextInputComponent,
    cOrgCurrencyDp,
    cDropDown,
    cPaymentTypes,
    ValidationObserver,
    cStatusButton,
    cAlertModal
  },

  data: () => {
    return {
      isEdit: false,
      alertValue: null,
      isShowAlertModal: false,

      payment: {
        name: null,
        providerGroup: null,
        provider: null,
        currencyList: [],
        feeSettings: [],
        status: null
      }
    };
  },

  computed: {
    ...mapGetters("sPaymentSetup", { selectedPayment: "GET_SELECTED_PAYMENT" }),

     ...mapGetters("sCurrencyLs", {
      GET_ORG_CURRENCY_RES: "GET_ORG_CURRENCY_RES"
    }),
  },

  methods: {
    ...mapActions("sPaymentSetup", {
      SET_SELECTED_PAYMENT: "SET_SELECTED_PAYMENT"
    }),

    onEdit() {
        try {
          if(BaseConfiguration.isDebug) console.log("onEdit");
        
    updateDataEdited(true);
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.ADD_PAYMENT,
                  "error in onEdit",
                  err.toString(),
                  "onEdit",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 

             getAlertModalBtn() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getAlertModalBtn");

        retValue = [
          {
            name: this.$t("addPayment.ok"),
            func: this.navigateToPaymentSetup
          }
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_PAYMENT,
          "error in getAlertModalBtn",
          err.toString(),
          "getAlertModalBtn",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toggleAlertModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleAlertModal");
        this.isShowAlertModal = !this.isShowAlertModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_PAYMENT,
          "error in toggleAlertModal",
          err.toString(),
          "toggleAlertModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },






  navigateToPaymentSetup()
  {
      goBack()
  },



 
    navigateToPaymentFee() {
      if (this.selectedPayment && this.selectedPayment.paymentsettingsid)
        navigate(PATHNAME.PAYMENT_FEE);
    },

 

    async getPaymentTypes(pPaymentSettID) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getPaymentTypes");
        let paymentTypesReq = apiGetPaymentTypes.buildRequest(pPaymentSettID);
        if (paymentTypesReq && pPaymentSettID != null) {
          let paymentTypesRes = await apiGetPaymentTypes.getResponse(
            paymentTypesReq
          );
          if (VALIDATE_SUCCESS_RES(paymentTypesRes)) {
            retValue = paymentTypesRes.data.data;
            this.alertValue = null;
          } else {
            let error = getErrorMessage(paymentTypesRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid  payment setting id";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_PAYMENT,
          "error in getPaymentTypes",
          err.toString(),
          "getPaymentTypes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async updatePayment() {
      let retValue;
      try {
        
        updateDataEdited(false);
        if (BaseConfiguration.isDebug) console.log("updatePayment");
        let updatePaymentReq = apiUpdatePayment.buildRequest(
          cloneData(this.getPaymentReq(true))
        );
        if (updatePaymentReq) {
          let updatePaymentRes = await apiUpdatePayment.getResponse(
            updatePaymentReq
          );
          if (VALIDATE_SUCCESS_RES(updatePaymentRes)) {
            if (updatePaymentRes && updatePaymentRes.data)
              retValue = updatePaymentRes.data;
            else retValue = [];

            // this.showAlertModal(
            //                     ALERT_MODAL_STATUS.SUCCESS,
            //                     'Updated successfully',
                        
            //                 );
            this.alertValue = null;
          } else {
            let error = getErrorMessage(updatePaymentRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
            //  this.showAlertModal(
            //                     ALERT_MODAL_STATUS.FAIL,
            //                     this.alertValue
            //                 );
          }
        } else {
          throw "invalid update  payment request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_PAYMENT,
          "error in updatePayment",
          err.toString(),
          "updatePayment",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

      return retValue;
    },

    async createPayment() {
      let retValue;
      try {
        
        updateDataEdited(false);
        if (BaseConfiguration.isDebug) console.log("createPayment");
        let createPaymentReq = apiCreatePayment.buildRequest(
          cloneData(this.getPaymentReq())
        );
        if (createPaymentReq) {
          let createPaymentRes = await apiCreatePayment.getResponse(
            createPaymentReq
          );
          if (VALIDATE_SUCCESS_RES(createPaymentRes)) {
            if (createPaymentRes && createPaymentRes.data.data)
              retValue = createPaymentRes.data.data;
            else retValue = [];

            //  this.showAlertModal(
            //                     ALERT_MODAL_STATUS.SUCCESS,
            //                     this.$t('addProfile.addSuccess'),
                        
            //                 );
            this.alertValue = null;
          } else {
            let error = getErrorMessage(createPaymentRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
            // this.showAlertModal(
            //                     ALERT_MODAL_STATUS.FAIL,
            //                     this.alertValue
            //                 );
          }
        } else {
          throw "invalid  create payment request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_PAYMENT,
          "error in createPayment",
          err.toString(),
          "createPayment",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

      return retValue;
    },

    getCurrencyCodes(pCurrencyList) {
      let retValue = [];

      try {
        if (BaseConfiguration.isDebug) console.log("getCurrencyCodes");
        let lsCurrencyCodes = [];

        pCurrencyList.forEach(currency => {
          if (
            currency &&
            currency.currency_code &&
            currency.currency_code.code
          ) {
            lsCurrencyCodes.push(currency.currency_code.code);
          }
        });

        retValue = cloneData(lsCurrencyCodes);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_PAYMENT,
          "error in getCurrencyCodes",
          err.toString(),
          "getCurrencyCodes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    filterPaymentTypeList(pPaymentTypeList, isEdit) {
      let retValue = [];
      try {
        if (!isEdit)
          pPaymentTypeList = pPaymentTypeList.filter(pType => {
            return pType.isActive;
          });

        pPaymentTypeList.forEach(pType => {
          pType.paymentType = pType.payment_type;
          delete pType.payment_type;
          delete pType.typename;
          if (!isEdit) delete pType.isActive;
        });

        retValue = pPaymentTypeList;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_PAYMENT,
          "error in filterPaymentTypeList",
          err.toString(),
          "filterPaymentTypeList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getPaymentReq(isUpdate) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getPaymentReq");
        let paymentObj = cloneData(this.payment);

        if (paymentObj) {
          let paymentReq = {};

          paymentReq.name = paymentObj.name ? paymentObj.name : null;
          paymentReq.providerGroupId =
            paymentObj.providerGroup && paymentObj.providerGroup.groupid
              ? paymentObj.providerGroup.groupid
              : null;
          paymentReq.providerId =
            paymentObj.provider && paymentObj.provider.providerid
              ? paymentObj.provider.providerid
              : null;
          paymentReq.currencyList =
            paymentObj.currencyList && paymentObj.currencyList.length
              ? this.getCurrencyCodes(paymentObj.currencyList)
              : null;
          paymentReq.feeSettings =
            paymentObj.feeSettings && paymentObj.feeSettings.length
              ? this.filterPaymentTypeList(paymentObj.feeSettings, isUpdate)
              : null;

          if (isUpdate) {
            paymentReq.status = paymentObj.status;
            paymentReq.paymentSettingId = this.selectedPayment.paymentsettingsid;
          }
          Object.keys(paymentReq).forEach(key => {
            if (!paymentReq[key]) {
              throw key.toString() + " is invalid";
            }
          });

          retValue = paymentReq;
        } else {
          throw "invalid payment obj";
        }
        //  paymentReq.feeSettings=paymentObj.
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_PAYMENT,
          "error in getPaymentReq",
          err.toString(),
          "getPaymentReq",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getPaymentGroupsUrl() {
      return SERVICE_URL.GET_PAYMENT_GROUP;
    },

    getPaymentProvidersUrl() {
             let returnValue;
      if(this.selectedPayment)
      {
        returnValue= SERVICE_URL.GET_PAYMENT_PROVIDER

      }
      else
      {
              returnValue = SERVICE_URL.GET_PAYMENT_PROVIDER_FOR_CREATE;
      }
      return returnValue
    },

    getStatusUrl() {
      return SERVICE_URL.STATUS;
    },

    cnfrmPaymentSubmit() {
        try {
          if(BaseConfiguration.isDebug) console.log("cnfrmPaymentSubmit");
           this.showAlertModal(
                        ALERT_MODAL_STATUS.INFO,
                        'Do you wanna save the changes',
                        
                    );
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.ADD_PAYMENT,
                  "error in cnfrmPaymentSubmit",
                  err.toString(),
                  "cnfrmPaymentSubmit",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
    }, 
    async onPaymentFormSubmit() {
      try {
        if (BaseConfiguration.isDebug) console.log("onPaymentFormSubmit");
        if (this.selectedPayment) {
          
          let updatePaymentStatus = await this.updatePayment();
          if (updatePaymentStatus != null) {
            if(!this.payment.status.value)
            {
                   this.toggleAlertModal();
            }
            else
            this.navigateToPaymentFee();
          }
        } else {
          let createPaymentStatus = await this.createPayment();
          if (createPaymentStatus && createPaymentStatus.paymentsetting_id) {
            createPaymentStatus.paymentsettingsid =
              createPaymentStatus.paymentsetting_id;
            this.SET_SELECTED_PAYMENT(cloneData(createPaymentStatus));
            this.navigateToPaymentFee();
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_PAYMENT,
          "error in onPaymentFormSubmit",
          err.toString(),
          "onPaymentFormSubmit",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onPaymentTypeChange(pPaymentSett) {
      try {
        if (BaseConfiguration.isDebug) console.log("onPaymentTypeChange");
        pPaymentSett = cloneData(  pPaymentSett);

        if (
          pPaymentSett &&
          pPaymentSett.B2B &&
          pPaymentSett.B2B.length &&
          pPaymentSett.B2C &&
          pPaymentSett.B2C.length
        )
          this.payment.feeSettings = pPaymentSett.B2B.concat(pPaymentSett.B2C);

        // alert(JSON.stringify(this.payment.feeSettings));
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_PAYMENT,
          "error in onPaymentTypeChange",
          err.toString(),
          "onPaymentTypeChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },

  async created() {
    updateDataEdited(true);
    if (this.selectedPayment) {
      this.payment.name = this.selectedPayment.providername;
      this.payment.providerGroup = { groupid: this.selectedPayment.groupid };
      this.payment.provider = {
         providerid:this.selectedPayment.paymentProviderId,
         
        providertype: this.selectedPayment.providertype
      };

      this.payment.currencyList = this.selectedPayment.acceptableCurrencies;

      this.payment.status = {
        name: this.selectedPayment.isActive ? this.$t('addPayment.active') : this.$t('addPayment.inactive'),
        value: this.selectedPayment.isActive
      };

      this.payment.currencyList = [];

      if (
        this.selectedPayment.acceptableCurrencies &&
        this.selectedPayment.acceptableCurrencies.length
      ) {
        this.selectedPayment.acceptableCurrencies.forEach(currency => {
          this.payment.currencyList.push({
            currency_code: {
              code: currency
            }
          });
        });

        this.payment.feeSettings = await this.getPaymentTypes(
          this.selectedPayment.paymentsettingsid
        );
      }
    }else{
      this.payment.status = {
        name: this.$t('addPayment.active'),
        value: true
      };
  

    }
  },
   beforeCreate() {    
   addClassToBody(COMPONENT_NAME.ADD_PAYMENT);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
};
</script>

<style scoped></style>
